'use client';

import React, { PropsWithChildren } from 'react';
import {
  UnauthenticatedLayout,
  UnauthenticatedLayoutProps
} from '@ianesthesie-kit/common-pages';
import { styled } from '@mui/material';
import AuthPageIllustration from '../../../public/LandingAnimationManHoopcare.gif';
import { CenteredContainer, ResponsiveBox } from '@ianesthesie-kit/core';

const ImageContainer = styled('div')`
  position: relative;
  width: 100%;
  height: 100%;

  img {
    display: block;
    width: 100%;
    height: auto;
  }
`;

const Container = styled('div')`
  main > div:first-of-type {
    display: flex;
    align-items: center;
    background-color: #f5f7fa;
  }

  @media (max-width: 1500px) {
    main > div:last-of-type > div {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }

  // TODO replace this cryptic selector with a component prop in kit
  main > div:last-of-type > div > div:last-of-type {
    width: 100%;
  }
`;

const InnerWrapper = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const AuthPageIllustratedLayout = ({
  children,
  ...props
}: PropsWithChildren<UnauthenticatedLayoutProps>) => (
  <Container className="container">
    <UnauthenticatedLayout
      langSelectorContainerProps={{
        sx: {
          position: 'absolute',
          width: '100%',
          zIndex: 2,
          transform: 'scale(0.8)',
          mr: 0,
          '& button': {
            p: 0,
            fontSize: '1.7rem',
            lineHeight: '1.8rem'
          }
        }
      }}
      imgSrc={AuthPageIllustration}
      imgProps={{
        priority: true,
        unoptimized: true,
        loading: 'eager',
        placeholder: 'blur',
        blurDataURL: '../../../LandingAnimationManHoopcare_placeholder.gif',
        alt: 'Auth page decorative illustration',
        style: { objectPosition: 'center', objectFit: 'contain' }
      }}
      imageContainer={({ children: image, ...p }) => (
        <ResponsiveBox
          hiddenDown="sm"
          sx={{
            display: 'flex',
            position: 'relative',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            height: '100%',
            width: {
              xs: '70%',
              lg: '50%'
            }
            // transform: 'translateY(20%)',
            // minWidth: 300,
            // marginX: 'auto',
            // boxSizing: 'content-box',
            // '@media (orientation: landscape)': (t) => ({
            //   [t.breakpoints.down('md')]: {
            //     transform: 'translateY(10%)'
            //   }
            // })
          }}
          {...p}
        >
          <ImageContainer sx={{ overflowY: 'hidden', mx: 'auto' }}>
            {image}
          </ImageContainer>
        </ResponsiveBox>
      )}
      {...props}
    >
      <InnerWrapper className="innerwrapper">
        <CenteredContainer flexGrow={1}>{children}</CenteredContainer>
      </InnerWrapper>
    </UnauthenticatedLayout>
  </Container>
);
